import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Config } from './types/Config';
import { Menu } from './types/Menu';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-accordion-menu',
    imports: [RouterLink, FontAwesomeModule],
    templateUrl: './accordion-menu.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './accordion-menu.component.scss'
})
export class AccordionMenuComponent implements OnChanges {
  @Input() options: any;
  @Input() menus: Menu[] = [];
  @Input() activeRoute: string | undefined;
  _menus: Menu[] = [];
  config: Config
  chevronDown = faChevronDown;

  constructor() {
    this.config = this.mergeConfig(this.options);
    let menu = this._menus.filter(menu =>
      menu.url == this.activeRoute || menu.submenu.some(s => s.url == this.activeRoute)
    )[0];

    if (menu) {
      menu.active = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['menus'] != null && changes['menus'].currentValue != null) {
      this._menus = changes['menus'].currentValue;
    }
  }

  mergeConfig(options: Config) {
    const config = {
      // selector: '#accordion',
      multi: true
    };

    return { ...config, ...options };
  }

  toggle(index: number) {
    
    if (!this.config.multi) {
      this.menus.filter(
        (menu, i) => i !== index && menu.active
      ).forEach(menu => menu.active = !menu.active);
    }

    this.menus[index].active = !this.menus[index].active;
  }

}
